import { RouteObject } from 'react-router-dom'
import EasyPayPage from './easyPayPage'
import EasyPayLayout from 'layout/easyPay/easyPayLayout'
import InitPage from './init'
import MoneyPool from './moneyPool'
import InitMoneyPool from './initMoneyPool'
import PayForOther from './payForOther'
import PayForOtherInLoan from './payForothersInLoan'
import ErrorBug from 'components/errors/bugs'
import EasyGatewayPayPage from './easyPayPage/indexEasyGatewaypage'
import InitGatewayPaymentPage from './init/indexGateway'

export const easyPayLayout: RouteObject[] = [
    {
        path: '/easy-pay',
        element: <EasyPayLayout />,
        errorElement: <ErrorBug />,
        children: [
            {
                index: false,
                path: '',
                element: <EasyGatewayPayPage />,
            },
            {
                index: false,
                path: 'gateway',
                element: <EasyPayPage />,
            },
            {
                index: false,
                path: 'init',
                element: <InitPage />,
            },
            {
                index: false,
                path: 'init-new',
                element: <InitGatewayPaymentPage />,
            },
            {
                index: false,
                path: 'money-pool/:id',
                element: <MoneyPool />,
            },
            {
                index: false,
                path: 'money-pool/init/:id',
                element: <InitMoneyPool />,
            },
            {
                index: false,
                path: 'pay-for-other/:moneyPool',
                element: <PayForOther />,
            },
            {
                index: false,
                path: 'pay-for-other-in-loan/:moneyPool',
                element: <PayForOtherInLoan />,
            },
        ],
    },
]
